/* global locale */
import CookieConsent from '../shared/cookie_consent.vue'
import VeeValidate, { Validator } from 'vee-validate'
import VueI18n from 'vue-i18n'
import Vue from 'vue/dist/vue.esm'
Vue.use(VueI18n)
import TurbolinksAdapter from 'vue-turbolinks'
Vue.use(TurbolinksAdapter)
import { messages } from 'default/translated_text'

function cookie_tracked() {
  return document.getElementsByClassName('cookie-consent-dropdown')[0] == null
}

function add_div() {
  var cookie_consent_div = document.createElement('div')
  cookie_consent_div.setAttribute('id', 'cookie-consent')
  var parentDiv = document.getElementsByTagName('header')[0]
  parentDiv.appendChild(cookie_consent_div)
}

function add_cookie_consent() {
  if (cookie_tracked()) { return }

  if (document.getElementById('cookie-consent') == null) {
    add_div()
  }

  add_cookie_component()
}

function add_cookie_component() {
  Vue.use(VeeValidate, {events: 'blur'})
  Validator.localize(window.locale, messages[window.locale])
  const i18n = new VueI18n({ locale, messages, fallbackLocale: 'en' })
  new Vue({
    i18n,
    el: '#cookie-consent',
    components: { CookieConsent },
    template: '<CookieConsent/>'
  })
}

document.addEventListener('turbolinks:load', function(){
  add_cookie_consent()
}, true)
